import { useState } from 'react'
import { searchUSN } from '../../api'
import toastService from '../../toast'
import { useNavigate } from 'react-router-dom'

const Home = () => {
    const navigate = useNavigate()
    const [USN, setUSN] = useState('')

    const submit = async (e) => {
        try {
            e.preventDefault()
            const response = await searchUSN(USN)
            if (response.data?.status === 'success'){
                navigate(`/${response.data.id}`)
            }else {
                toastService.error('Invalid USN')
            }

        } catch (error){
            console.log({ error })
            toastService.error('Invalid USN')
        }
    }

    return (
        <div className="home">
            <div className="home__imageContainer">
                <img src="/assets/certificate/BG.png" alt="" />
                <div className="home__headingContainer">
                    <h1>Certificate Verification</h1>
                    <span>Verify the credential of certificate offered to Businesstoys students.</span>
                </div>
                <form onSubmit={submit} className="home__certificate">
                    <h1>Enter USN Number</h1>
                    <input placeholder="Enter USN" type="text" 
                        value={USN} 
                        onChange={e => setUSN(e.target.value)}  />
                    <button>Submit</button>
                </form>
         </div>
        </div>
    );
}

export default Home;